import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Menu Items Management
export const createMenuItem = async (itemData) => {
  const response = await axios.post(`${API_BASE}/menu-items`, itemData, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const updateMenuItem = async (itemId, itemData) => {
  const response = await axios.put(`${API_BASE}/menu-items/${itemId}`, itemData, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const deleteMenuItem = async (itemId) => {
  const response = await axios.delete(`${API_BASE}/menu-items/${itemId}`, {
    headers: getAuthHeader()
  });
  return response.data;
};

// User Management (Super Admin only)
export const getUsers = async () => {
  const response = await axios.get(`${API_BASE}/auth/users`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const createUser = async (userData) => {
  const response = await axios.post(`${API_BASE}/auth/register`, userData, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const updateUser = async (userId, userData) => {
  const response = await axios.put(`${API_BASE}/auth/users/${userId}`, userData, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const deleteUser = async (userId) => {
  const response = await axios.delete(`${API_BASE}/auth/users/${userId}`, {
    headers: getAuthHeader()
  });
  return response.data;
};

// Contact Messages
export const getContactMessages = async () => {
  const response = await axios.get(`${API_BASE}/contact/messages`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const markMessageRead = async (messageId) => {
  const response = await axios.put(`${API_BASE}/contact/messages/${messageId}/read`, {}, {
    headers: getAuthHeader()
  });
  return response.data;
};
